import React from 'react';
import Loading from 'react-loading';

const Loader = () => {

  const absStyle: React.CSSProperties = {
    position: "absolute",
    top: "50%",
    marginTop: "-50px",
    zIndex: 2017
  };

  const overlayStyle: React.CSSProperties = {
    background: "rgb(226 233 233 / 40%)",
    justifyContent: 'center',
    width: "100%",
    height: (window.innerHeight - 10),
    zIndex: 99999,
    display: "flex",
  };

  return (
    <div className="overlay" style={overlayStyle}>
      <div style={absStyle}>
        <Loading
          type='spin'
          color={"red"}
          width={"50px"}
          height={"50px"}
        />
      </div>
    </div>
  );
};

export default Loader;